import { Action, createReducer, on } from '@ngrx/store';
import * as fromUWApprovalActions from '../uw-approval/uw-approval.actions';
import { initialState, UWApprovalState } from './uw-approval.state';

const _UWApprovalReducer = createReducer(
  initialState,
  on(
    fromUWApprovalActions.updateUWApprovalIsLoadingFromUWApprovalSavingData,
    (state, { isLoading }) => ({ ...state, isLoading: isLoading })
  )
);

export function UWApprovalReducer(
  state: UWApprovalState | null,
  action: Action
) {
  return _UWApprovalReducer(state, action);
}